import { render, staticRenderFns } from "./ListBusinessServices.vue?vue&type=template&id=63779b2e&scoped=true&lang=pug&"
import script from "./ListBusinessServices.vue?vue&type=script&lang=js&"
export * from "./ListBusinessServices.vue?vue&type=script&lang=js&"
import style0 from "./ListBusinessServices.vue?vue&type=style&index=0&id=63779b2e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63779b2e",
  null
  
)

export default component.exports